<div *ngFor="let widget of data.websectiondata">
  <!---- WIDGET 0  ----->
  <div class="wrapper-content-fitted wow fadeInUp" data-wow-delay="1s" *ngIf="widget.type == 0">
    <div class="theme-black" [innerHTML]="widget.content.es">
      <p></p>
    </div>
  </div>

  <!---- WIDGET 1  ----->
  <div class="wrapper-content-fitted wow fadeInUp" data-wow-delay="1s" *ngIf="widget.type == 1">
    <img src="{{api.getImageUrl(widget.image)}}" alt="{{widget.name}}">
    <p class="theme-black" style="text-align: center; width: 100%">{{widget.title}}</p>
  </div>
  <!---- WIDGET 2  ----->
  <div class="wrapper-content black wow fadeInUp" data-wow-delay="1s" *ngIf="widget.type == 2">
    <div class="video-pane flex">
       <iframe width="68%" height="100%" [src]="api.getVideoIframe(widget.link)" style="margin: auto" frameborder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>

    </div>
  </div>
  <!---- WIDGET 3  ----->
  <div class="wrapper-content-fitted wow fadeInUp" data-wow-delay="1s" *ngIf="widget.type == 3">
    <div class="col-12 app-slider-wrapper" magic [magicCss]="{type: 'rectangle'}" style="padding:  0;">
      <mat-carousel magic [magicCss]="{type: 'rectangle'}" class="app-slider" *ngIf="widget.websectiondataitem.length>0"
        timings="250ms ease-in" [autoplay]="true" interval="5000" color="accent" maxWidth="auto" proportion="40"
        slides="5" [loop]="true" [autoplay]="false" [hideArrows]="false" [hideIndicators]="true" [useKeyboard]="true"
        [useMouseWheel]="false" orientation="ltr">
        <mat-carousel-slide magic
        [magicCss]="{type: 'rectangle'}" #matCarouselSlide
          *ngFor="let slide of widget.websectiondataitem; let i = index"
          overlayColor="#00000040" [hideOverlay]="false">
          <div magic [magicCss]="{type: 'rectangle', background: api.getImageUrl(slide.image)}"
          style="padding:  0;" class="app-slider-item col-12">
            <a href="{{api.getImageUrl(slide.image)}}"
            class="app-slider-copyright">{{slide.title.es}}</a>
          </div>
        </mat-carousel-slide>
      </mat-carousel>
    </div>


  </div>

  <!---- WIDGET 4  ----->
  <div class="wrapper-content-fitted" *ngIf="widget.type == 4">
    <div class="col-12" style="margin-bottom: 60px; padding: 0;">
      <mat-accordion  #firstAccordion="matAccordion"  multi="true">
        <mat-expansion-panel *ngFor="let item of widget.websectiondataitem; let i = index">
          <mat-expansion-panel-header class="ts-background-5">
            <mat-panel-title>
              <h4> {{item.title.es}}</h4>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <p [innerHTML]="item.content.es"></p>
          <img *ngIf="item.image && item.image!=''" src="{{api.getImageUrl(item.image)}}" style="max-height: 400px;"
            alt="">
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </div>

  <!---- WIDGET 5  ----->
  <div class="wrapper-content" *ngIf="widget.type == 5">
    <div class="col-xs-12 col-md-10 offset-md-1">
      <a href="{{widget.link}}" target="_blank" class="btn-theme ts-background-5">{{widget.title}}</a>
    </div>
  </div>

  <!---- WIDGET 6  ----->
  <div class="wrapper-content-fitted" *ngIf="widget.type == 6">
    <div class="wwf-box" *ngFor="let item of widget.websectiondataitem; let i = index">
      <div class="wwf-card-small">
        <a href="{{item.link}}" target="_blank" class="wwf-card--mask"></a>
        <div class="wwf-card--body">
          <h4 class="wwf-card--title">{{item.title.es}}</h4>
        </div>
        <div class="wwf-card--btn ts-background-1">
          <svg xmlns="http://www.w3.org/2000/svg" width="40.001" height="40" viewBox="0 0 40.001 40">
            <path id="ver-mas" d="M17.5-7850v-17.5H0v-5H17.5V-7890h5v17.5H40v5H22.5v17.5Z" transform="translate(0 7890)"
              fill="#fff" />
          </svg>
        </div>
      </div>
    </div>
  </div>

  <!---- WIDGET 7  ----->
  <div class="wrapper-content" *ngIf="widget.type == 7">
    <div class="wrapper-header">
      <h1 class="text-center">{{widget.title}}</h1>
      <h5 class="text-center" [innerHTML]="widget.content.es"></h5>
    </div>
  </div>

  <!---- WIDGET 11 ----->
  <div class="widget-11" *ngIf="widget.type == 11">

    <div class="widget-11--pane-left wow slideInLeft" data-wow-delay="1s">
      <h2>{{widget.title}}</h2>
      <div [innerHTML]="widget.content.es"></div>
    </div>
    <div class="widget-11--pane-right wow slideInLeft" data-wow-delay="1s"
      [style.background]="'url('+api.getImageUrl(widget.image)+')'">
    </div>
    <div class="panel-color left-top small wow slideInLeft" data-wow-delay="1s"></div>
    <div class="panel-color ts-background-3 right-top big wow slideInRight" data-wow-delay="1s"></div>

  </div>

  <!---- WIDGET 12 ----->
  <div class="widget-12" *ngIf="widget.type == 12">
    <div class="widget-12--pane-left" [style.background]="'url('+api.getImageUrl(widget.image)+')'">
    </div>
    <div class="widget-12--pane-right wow slideInLeft" data-wow-delay="1s">
      <h2>{{widget.title}}</h2>
      <div [innerHTML]="widget.content.es"></div>
    </div>
    <div class="panel-color ts-background-4 left-top big wow slideInLeft" data-wow-delay="1s"></div>
    <div class="panel-color right-top small wow slideInRight" data-wow-delay="1s"></div>
  </div>

  <!---- WIDGET 14 ----->
  <div class="widget-14" *ngIf="widget.type == 14">
    <div class="widget-14--pane-left animate__animated animate__fadeInUp animate__faster animate__delay-2s"
      [style.background]="'url('+api.getImageUrl(widget.image)+')'">
    </div>
    <div class="widget-14--pane-right  animate__animated animate__fadeInRight animate__faster animate__delay-2s">
      <h2>{{widget.title}}</h2>
      <div [innerHTML]="widget.content.es" (click)="open(content)"></div>
    </div>

    <div class="panel-color ts-background-3 left-top big  fadeInLeft"></div>
    <div class="panel-color right-top small  fadeIn"></div>
  </div>

  <!---- WIDGET 13 ----->
  <!-- <div class="wrapper-content-fitted" *ngIf="widget.type == 13">
    <div class="images-pane" *ngIf="widget.websectiondataitem">
      <img src="{{api.getImageUrl(item.image)}}" alt="{{item.name}}" *ngFor="let item of widget.websectiondataitem">
    </div>
  </div> -->

</div>



<ng-template #content let-modal>
  <div class="modal-header">
    <h1 class="text-center"></h1>
    <a class="closebtn" (click)="modal.dismiss('Cross click')">
      <svg xmlns="http://www.w3.org/2000/svg" width="46.669" height="46.669" viewBox="0 0 46.669 46.669">
        <g id="close" transform="translate(-41.665 -25.665)">
          <rect id="Rectángulo_3" data-name="Rectángulo 3" width="60" height="6"
            transform="translate(45.908 25.665) rotate(45)" fill="#000" />
          <rect id="Rectángulo_41" data-name="Rectángulo 41" width="60" height="6"
            transform="translate(88.334 29.908) rotate(135)" fill="#000" />
        </g>
      </svg>
    </a>
  </div>
  <div class="modal-body" *ngIf="selected">
    <div *ngFor="let widget of selected.websectiondata">
    </div>
  </div>
</ng-template>
